import {
  SCORM_UPLOAD,
  SCORM_UPLOAD_SUCCESS,
  SCORM_UPLOAD_ERROR,
  SCORM_REPLACE,
  SCORM_REPLACE_SUCCESS,
  SCORM_REPLACE_ERROR,
  SCORM_DELETE,
  SCORM_DELETE_SUCCESS,
  SCORM_DELETE_ERROR,
  SCORM_TRACK,
  SCORM_TRACK_SUCCESS,
  SCORM_TRACK_ERROR,
} from './type'

export const scormUploadAction = (file, blockId, callback, onProgress) => ({
  type: SCORM_UPLOAD,
  payload: { file, blockId, callback, onProgress },
})

export const scormReplaceAction = (file, scormId, blockId, callback, onProgress) => ({
  type: SCORM_REPLACE,
  payload: { file, scormId, blockId, callback, onProgress },
})

export const scormReplaceSuccess = response => ({
  type: SCORM_REPLACE_SUCCESS,
  payload: { response },
})

export const scormReplaceError = () => ({
  type: SCORM_REPLACE_ERROR,
})

export const scormDeleteAction = (id, callback) => ({
  type: SCORM_DELETE,
  payload: { id, callback },
})

export const scormDeleteSuccess = id => ({
  type: SCORM_DELETE_SUCCESS,
  payload: { id },
})

export const scormDeleteError = () => ({
  type: SCORM_DELETE_ERROR,
})

export const scormUploadSuccess = response => ({
  type: SCORM_UPLOAD_SUCCESS,
  payload: { response },
})

export const scormUploadError = () => ({
  type: SCORM_UPLOAD_ERROR,
})

export const scormTrackAction = (data, callback) => ({
  type: SCORM_TRACK,
  payload: { data, callback },
})

export const scormTrackSuccess = response => ({
  type: SCORM_TRACK_SUCCESS,
  payload: { response },
})

export const scormTrackError = () => ({
  type: SCORM_TRACK_ERROR,
})
